<template>
    <div class="next_checkbox">
        <q-checkbox
            v-bind="{...$attrs, ...$props}"
            :model-value="modelValue"
            @update:model-value="$emit('update:modelValue', $event)"
        />
    </div>
</template>

<script>
export default {
    name: 'NextCheckbox1',
    props: {
        modelValue: {
            type: String,
            default: null,
        },
        label: {
            type: String,
            default: '',
        },
    },
    emits: ['update:modelValue'],
};
</script>

<style>
.next_checkbox {
    color: var(--main-text);
    font-family: Montserrat, sans-serif;
    font-size: 16px;
    line-height: 24px;
}
.next_checkbox .q-checkbox__svg {
    color: var(--main-text);
    transform: scale(0.75);
}
.next_checkbox .q-checkbox__bg {
    border: 1.4px solid var(--main-text);
    border-radius: 4px;
}
.next_checkbox .q-checkbox__inner--truthy,
.next_checkbox .q-checkbox__inner--indet {
    color: transparent;
}
</style>
